module.exports = __webpack_public_path__ + "img/core01.e058d898.png";